"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=scene-child.js.map